export default function getCookieValue(value) {
  const re = new RegExp(`(?:(?:^|.*;\\s*)${value}\\s*\\=\\s*([^;]*).*$)|^.*$`);
  return decodeURIComponent(document.cookie.replace(re, '$1'));
}
